import { SVGProps } from "react";

interface TrophyIconProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
  width?: number;
  height?: number;
}

const TrophyIcon = ({ fillColor = "#E49D24", width = 40, height = 40, ...props }: TrophyIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M33.493 3.825h5.335v2.518c0 6.455-4.731 11.804-10.914 12.77" fill={fillColor} />
      <path d="M33.493 3.825h5.335v2.518c0 6.455-4.731 11.804-10.914 12.77" stroke="#000" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.087 19.113c-6.184-.966-10.915-6.315-10.915-12.77V3.825h5.335" fill={fillColor} />
      <path d="M12.087 19.113c-6.184-.966-10.915-6.315-10.915-12.77V3.825h5.335" stroke="#000" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.33 34.109v-5.706c0-2.893 1.358-5.599 3.626-7.395 4.52-3.578 7.633-11.102 7.633-19.805H6.41c0 8.703 3.114 16.227 7.633 19.805 2.268 1.796 3.626 4.502 3.626 7.395v5.706" fill={fillColor} />
      <path d="M22.33 34.109v-5.706c0-2.893 1.358-5.599 3.626-7.395 4.52-3.578 7.633-11.102 7.633-19.805H6.41c0 8.703 3.114 16.227 7.633 19.805 2.268 1.796 3.626 4.502 3.626 7.395v5.706m12.63 4.687H9.7" stroke="#000" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.045 38.796V34.11h15.91v4.687" fill={fillColor} />
      <path d="M12.045 38.796V34.11h15.91v4.687m5.538-34.972h5.335v2.518c0 6.455-4.731 11.804-10.914 12.77m-15.827 0c-6.184-.966-10.915-6.315-10.915-12.77V3.825h5.335" stroke="#000" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.33 34.109v-5.706c0-2.893 1.358-5.599 3.626-7.395 4.52-3.578 7.633-11.102 7.633-19.805H6.41c0 8.703 3.114 16.227 7.633 19.805 2.268 1.796 3.626 4.502 3.626 7.395v5.706m12.63 4.687H9.7m2.345 0V34.11h15.91v4.687" stroke="#000" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="rgb(var(--pd-white))" d="M0 0h40v40H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default TrophyIcon;
